import Button from "@commons/Button";
import Logo from "@commons/Logo";
import Heading from "@commons/Typography/Heading";
import Text from "@commons/Typography/Text";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center w-screen h-screen">
      <div className="flex flex-col items-center justify-center gap-4 bg-white p-8 rounded-lg shadow-md">
        <Logo className="mb-4" />
        <Heading size="xl">404</Heading>
        <Text customVariant="gray" size="md">
          Página não encontrada
        </Text>
        <Link to="/">
          <Button customVariant="secondary">
            Voltar para a página inicial
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
